module.exports = __webpack_public_path__ + "static/media/1B.557ac685.png";